"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _preactCompat = require("preact-compat");

var _phrase = _interopRequireDefault(require("../../../libs/translationsUtils/phrase"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ReportPrivateMessageButton = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(ReportPrivateMessageButton, _PureComponent);

  var _super = _createSuper(ReportPrivateMessageButton);

  function ReportPrivateMessageButton() {
    (0, _classCallCheck2.default)(this, ReportPrivateMessageButton);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(ReportPrivateMessageButton, [{
    key: "render",
    value: function render() {
      var onReport = this.props.onReport;
      return (0, _preact.h)("div", {
        className: "qa-private-message-report",
        onClick: onReport
      }, (0, _preact.h)(_phrase.default, {
        p: "privateMessages.conversation.reportButton"
      }));
    }
  }]);
  return ReportPrivateMessageButton;
}(_preactCompat.PureComponent);

var _default = ReportPrivateMessageButton;
exports.default = _default;